import { useStressAssessmentReportDownload } from './hooks';
import { convertToStressAssessmentReportDownloadProps } from './logics/convertToStressAssessmentReportDownloadProps';
import { StressAssessmentReportDownloadPresentation } from './presentations';

export const StressAssessmentReportDownload: React.FC = () => {
  const {
    state: { data, isLoading, selectedBranch, branchStats, stressAssessmentSummary },
    actions: { handleSetBranch },
  } = useStressAssessmentReportDownload();

  if (!data || isLoading) return null;

  const {
    branches,
    targetYearLabel,
    inspectionYearMonthLabel,
    inspectedCount,
    groupAnalysisCount,
  } = convertToStressAssessmentReportDownloadProps({
    data,
    branchStats,
    stressAssessmentSummary,
  });

  return (
    <StressAssessmentReportDownloadPresentation
      targetYearLabel={targetYearLabel}
      inspectionYearMonthLabel={inspectionYearMonthLabel}
      inspectedCount={inspectedCount}
      groupAnalysisCount={groupAnalysisCount}
      branches={branches}
      selectedBranch={selectedBranch}
      onChangeBranch={handleSetBranch}
    />
  );
};
